export const getPostalItemsUrl = '/ezcon/api/app/postalRegistration';

export const tabTypes = ['uncompleted', 'completed', 'return'];